export default "__VITE_ASSET__8bb63478__"